import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { RotaService } from "./RotaService";

interface RotaServiceProviderProps {
  children: React.ReactNode;
}

export const RotaServiceContext = React.createContext<RotaService | undefined>(undefined);

export const RotaServiceProvider: React.FC<RotaServiceProviderProps> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new RotaService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return <RotaServiceContext.Provider value={service}>{children}</RotaServiceContext.Provider>;
};

export const useRotaService = (): RotaService => {
  const context = React.useContext(RotaServiceContext);
  if (context === undefined) {
    throw new Error("useRotaService must be used within a RotaServiceProvider");
  }
  return context;
};
